/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import {
    OperatorAccHomePageActions,
    OperatorAccHomePageActionType,
    fetchOperatorAccDetailsSuccessAction,
    fetchOperatorAccHomeDataErrorAction,
    fetchOperatorAccCashboxesStatsSuccessAction,
} from '../../actions/OperatorAcc/OperatorAccHomeActions';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { operatorsClient } from '../../api/operators/operatorsClient';
import { AxiosError } from 'axios';
import { parseError } from '../../../utils/utils';
import { i18n } from '../../translation/i18n';

export const fetchOperatorAccDetailsEpic: Epic<OperatorAccHomePageActions> = (action$) => {
    return action$.pipe(
        ofType(OperatorAccHomePageActionType.OPEN_OPERATOR_ACC_HOME_PAGE),
        switchMap(() => {
            return from(operatorsClient.getOperatorAccDetails()).pipe(
                map((resp) => fetchOperatorAccDetailsSuccessAction(resp)),

                catchError((err: AxiosError) =>
                    of(
                        fetchOperatorAccHomeDataErrorAction(
                            parseError(err, i18n.t('RegistryScreens.errors.operatorDataNotFound')),
                        ),
                    ),
                ),
                takeUntil(action$.ofType(OperatorAccHomePageActionType.EXIT_OPERATOR_ACC_HOME_PAGE)),
            );
        }),
    );
};

export const fetchOperatorAccCashBoxesStatsEpic: Epic<OperatorAccHomePageActions> = (action$, state$) => {
    return action$.pipe(
        ofType(OperatorAccHomePageActionType.FETCH_OPERATOR_ACC_DETAILS_SUCCESS),
        switchMap(() => {
            const operatorTaxNumber = state$.value.operatorAccHomeReducer.operatorDetails.taxNumber;

            return from(operatorsClient.getOperatorCashBoxesStats(operatorTaxNumber)).pipe(
                map((resp) => {
                    return fetchOperatorAccCashboxesStatsSuccessAction(resp);
                }),

                catchError((err: AxiosError) =>
                    of(
                        fetchOperatorAccHomeDataErrorAction(
                            parseError(err, i18n.t('RegistryScreens.errors.cashBoxesStatsNotFound')),
                        ),
                    ),
                ),

                takeUntil(action$.ofType(OperatorAccHomePageActionType.EXIT_OPERATOR_ACC_HOME_PAGE)),
            );
        }),
    );
};
